<template>
  <div v-if="accordionData.length" id="Accordion">
    <div v-for="(item, index) in accordionData" :key="index" class="accordion-item-container">
      <button v-if="item.content" @click="toggle(index)" class="accordion-item-inner accordion-button px-0">
        <div class="accordion-header">
          <p class="accordion-title">{{ item.title }}</p>
          <i v-if="isOpen(index)" class="fa fa-chevron-down" aria-hidden="true"></i>
          <i v-else class="fa fa-chevron-right accordion-arrow" aria-hidden="true"></i>
        </div>
      </button>
      <div v-if="isOpen(index)" class="accordion-content">
        <p v-if="item.slug === 'how_it_works'" class="text">{{ item.content }}</p>
        <div v-else-if="item.slug === 'faqs'">
          <div v-for="(faq, i) in item.content" :key="i" class="mb-4">
            <p class="text mb-2">{{ faq.question }}</p>
            <p class="mb-0" v-html="decodeData(faq.answer)"></p>
          </div>
        </div>
        <div v-else-if="item.slug === 'related_content'">
          <RelatedContentList :articleArray="item.content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RelatedContentList from './RelatedContentList.vue';

export default {
  name: "ServiceAccordion",
  components: {
    RelatedContentList
  },
  data() {
    return {
      openIndex: null
    };
  },
  props: {
    accordionData: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
    isOpen(index) {
      return this.openIndex === index;
    },
    decodeData(data) {
      try {
        return Buffer.from(data, 'base64').toString('utf8')
      } catch (error) {
        return data;
      }
    }
  }
};
</script>

<style scoped>
#Accordion {
  width: 100%;
  margin-bottom: 8px;
  font-family: DMSans, sans-serif;

  .accordion-item-container {
    padding: 20px 0;
    transition: color 0.3s;

    &:not(:last-child) {
      border-bottom: 1px solid #e0e5f5;
    }

    &:hover .accordion-arrow {
      color: #192550;
    }
  }

  .accordion-item-inner {
    cursor: pointer;
    font-family: DMSans, sans-serif;
  }

  .accordion-button {
    width: 100%;
    border: none;
    background-color: unset;
  }

  .accordion-button:focus:not(:focus-visible) {
    outline: none;
  }

  .accordion-arrow {
    color: #aeb0bd;
    transition: color 0.3s;
  }

  .accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.8rem !important;
  }

  .accordion-title {
    font-family: "DMSans Bold" !important;
    color: #192550;
    font-size: 1.8rem;
    margin-bottom: 0;
  }

  .accordion-content {
    color: #122130;
    text-align: left;
    font-size: 1.8rem;
    line-height: 2.5rem;
    font-family: DMSans, sans-serif;
    white-space: pre-wrap;
    margin-top: 20px;
  }

  .text {
    color: #122130;
  }

  .accordion-content p {
    margin: 0;
  }
}
</style>
